export default __webpack_public_path__ + "static/media/ISA_cloudxier1.6170e13b.png";